import { TeacherSalaryType } from '../types'

export const TEACHER_SALARY_LABELS: Record<TeacherSalaryType, string> = {
  'per-lesson': 'Оплата за занятие',
  'per-duration': 'Оплата за длительность занятия',
  'per-student-hour': 'Оплата за человеко-часы',
}

export const TEACHER_SALARY_DESCRIPTIONS: Record<TeacherSalaryType, string> = {
  'per-lesson':
    'Фиксированная сумма за занятие, даже если урок был короче или длиннее обычного. Пример: ставка 800 руб. — за урок и 40, и 80 минут будет 800 руб.',
  'per-duration':
    'Сумма задается за выбранную длительность и растет пропорционально, если занятие идет дольше. Пример: 600 руб. за 40 минут — за 80 минут будет 1200 руб.',
  'per-student-hour':
    'Зарплата зависит от числа учеников и длительности занятия: больше учеников и времени, больше выплата. Пример: 200 руб. за 1 человеко-час, 5 учеников и 1 час — это 1000 руб.',
}

export const TEACHER_SALARY_OPTIONS: Array<{
  value: TeacherSalaryType
  label: string
}> = [
  { value: 'per-lesson', label: TEACHER_SALARY_LABELS['per-lesson'] },
  { value: 'per-duration', label: TEACHER_SALARY_LABELS['per-duration'] },
  {
    value: 'per-student-hour',
    label: TEACHER_SALARY_LABELS['per-student-hour'],
  },
]

export const getTeacherSalaryTypeLabel = (
  type?: TeacherSalaryType | null,
) => {
  return type ? TEACHER_SALARY_LABELS[type] : null
}

export const getTeacherSalaryTooltip = (
  type?: TeacherSalaryType | null,
) => {
  return type ? TEACHER_SALARY_DESCRIPTIONS[type] : null
}

export const formatTeacherSalaryShort = ({
  type,
  salary,
  durationMinutes,
}: {
  type?: TeacherSalaryType | null
  salary?: number | null
  durationMinutes?: number | null
}) => {
  if (salary === null || salary === undefined || !type) {
    return '-'
  }

  switch (type) {
    case 'per-lesson':
      return `${salary}/урок`
    case 'per-duration':
      return durationMinutes
        ? `${salary}/${durationMinutes} мин.`
        : `${salary}/мин.`
    case 'per-student-hour':
      return `${salary}/чел.-час`
    default:
      return '-'
  }
}
